export default {
  project: [
    {
      id: 'introduction',
      label: 'tabs#project_introduction',
    },
    {
      id: 'witnesses',
      label: 'tabs#project_witnesses',
    },
    {
      id: 'digital-resource',
      label: 'tabs#project_digital_resource',
    },
    {
      id: 'notes',
      label: 'tabs#project_notes',
    },
    {
      id: 'stemma',
      label: 'tabs#project_stemma',
    },
    // {
    //   id: 'glossary',
    //   label: 'tabs#project_glossary',
    // },
    {
      id: 'bibliography',
      label: 'tabs#project_bibliography',
    },
  ],
};
